<script>
import OrdersApi from "@/services/orders-api";
import AvoirRequestApi from "@/services/avoirRequest-api";
import ItemsApi from "@/services/items-api";
import VueBarcode from 'vue-barcode';

export default {

  components: {
     VueBarcode
  },

  props: {
    onClose:{
      type:Function,
      default: null
    }, 
    title:{
      type:String,
      default: ""
    },

    showAddNewAvoirModal:{
      type:Boolean,
      default: false
    },
    isNew:{
      type:Boolean,
      default: false
    },

    propsAvoirId:{
      type:Number,
      default: null
    },

    isSearchAvoirItemWithBarcodeScannerEnabled: Boolean
  },

  data() {
    return {
        localShowAddNewAvoirModal: this.showAddNewAvoirModal,

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],
        isTableLoading: false,

        orderSelected:null,
        orderLineSelected:null,
        avoir:{} ,
        avoirLines:{} ,

        start:null ,
        end:null ,
        orderLines: [] ,
        quantityAvoir:0 ,
        confirmedQuantityAvoir:0 ,
        reason:null ,
        avoirRequestId:null ,
        selectedItem: { },
        batchDate:"",
        expirationDate:"",
        blNumber:"",
        batchNumber:"",
        showItemsModal:false ,
        itemsFilter: '',
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        isItemsTableBusy: false,
        endOfFindItems:false,
        itemsList: [],
        itemLines: [],
        itemFields: [
        {key:"actions", label:""},
        { key:"ref", label: "Réference", sortable: false, tdClass:"text-left align-middle"},
        { key:"title", label: "Article", sortable: false, tdClass:"text-left font-weight-bold  align-middle"},
        { key:"packageCount", label:"Unités par carton", thClass:"text-right", tdClass:"text-right align-middle", thStyle:"width:150px;"}, 
        { key:"priceTaxIncl", label:"Prix TTC", thClass:"text-right ", tdClass:"text-right font-weight-bold align-middle", thStyle:"width:100px;"}, 
        
        // { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discount", label: "remise (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discountedPrice", label: "P.U.Remisé (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
      ],
        //item:null,

    };
  },

  mounted(){

    this.findItems();
    //this.getOrders()

    var date = new Date();
      
      this.start = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.start.getTimezoneOffset()
      this.start= new Date(this.start.getTime() - (startoffset*60*1000))
      this.start=this.start.toISOString().split('T')[0]

      this.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const endoffset = this.end.getTimezoneOffset()
      this.end= new Date(this.end.getTime() - (endoffset*60*1000))
      this.end=this.end.toISOString().split('T')[0]
  },
  
  computed: {
        role() {
          return this.$cookies.get('userr');
        },

        isAvoirWithExpirationDateEnabled(){
          return  process.env.VUE_APP_FEATURE_AVOIR_WITH_EXPIRATION_DATE === 'true'
        },

        ischeckBlNumberAvoir(){
          return  process.env.VUE_APP_FEATURE_CHECK_BL_NUMBER_AVOIR === 'true'
        },

        isMSS(){
          return process.env.VUE_APP_CLIENT_NAME === "mss"
        },

        
    },

  methods: {


    onShown() {
      if (this.isSearchAvoirItemWithBarcodeScannerEnabled) {
        this.$nextTick(() => {
          this.$refs.itemInput.focus();
        });
      }
    },

    formatExpirationDateInput(value) {
      const digits = String(value || '').replace(/\D/g, '').slice(0, 4);
      let month = digits.slice(0, 2);
      const year = digits.slice(2);

      if (month.length === 2 && Number(month) > 12) {
        month = '12';
      }

      this.expirationDate = year ? month + '/' + year : month;
    },

    printModal() {
      this.applyPrintStylesForModal();
      this.$nextTick(() => {
        window.print();
      });
    },
    applyPrintStylesForModal(modalSelector = '.avoir-printable-modal') {
      const style = document.createElement('style');
      style.id = 'print-modal-style';

      style.textContent = `
        @media print {
          body {
            margin: 0 !important;
            padding: 0 !important;
            top: 0 !important;
            left: 0 !important;
            background: white !important;
            overflow: visible !important;
            -webkit-print-color-adjust: exact;
          }
          body * {
            visibility: hidden !important;
          }
          ${modalSelector}, ${modalSelector} * {
            visibility: visible !important;
          }
        }
      `;

      document.head.appendChild(style);

      function cleanup() {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
        window.removeEventListener('afterprint', cleanup);
      }

      window.addEventListener('afterprint', cleanup);
    },
    findItems(barcode){ 
      
      if(barcode){
        this.itemsFilter = barcode
      }

    this.isItemsTableBusy = true;
    this.itemsListTimestamp = new Date().getTime();
    ItemsApi.findItems(this.pagemodelMain.currentPage, this.pagemodelMain.perPage, 
                [], 
                this.itemsFilter, 
                null, null, false, null, null,null,null, null, null,
                null, false,false,false,false,false,false,false,
                this.itemsListTimestamp
                )

      .then(itemsList => {
    
        this.itemLines=itemsList.list ;
        this.pagemodelMain.totalRows = itemsList.total;
        this.pagemodelMain.currentPage = itemsList.page;
        this.pagemodelMain.perPage = itemsList.pageSize;
        this.pagemodelMain.pageSize = itemsList.pageSize;

        if(barcode && this.itemLines.length == 1){
          this.addItems(this.itemLines[0])
        }
      })
      .finally(() => {
        this.isItemsTableBusy = false;
        this.endOfFindItems = true;
      });
  },

  addItems(item){
    this.selectedItem = item;
    this.showItemsModal=false
    },

    showitemModal(){
      this.showItemsModal=true;
    },

    onCloseAddNewAvoirModal(){
      this.selectedItem = {};
      this.batchNumber=""
      this.batchDate=""
      this.expirationDate=""
      this.blNumber=""
      this.onClose()
      if(this.role == 0 && this.avoirRequestId ){
        AvoirRequestApi.deleteAvoirRequestIfEmpty(this.avoirRequestId ).then(
          this.onClose()
        )
      }else{
        this.onClose()
      }
    }, 

    refusedAvoirRequest(){
      const status = 3 ;
      AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , null , status )
        .then(avoirId => {
            if(avoirId) {
            this.avoirRequestId = avoirId 
            this.onCloseAddNewAvoirModal()
            }
          })
    },

    validateRequest(){
      AvoirRequestApi.validateRequestAvoir(this.avoir )
      .then(()=>{
        this.onCloseAddNewAvoirModal()
            })
    },

    requestAvoirStatusToLabel(status){
      switch(status){
        case 0: return 'Brouillon';
        case 1: return 'Envoyée';
        case 2:return 'Traitée';
        case 3 :return 'Refusée';
        default: return '_'
      }
    },

    requestAvoirToColor(status){
      switch(status){
        case 0: return 'secondary';
        case 1: return 'warning';
        case 2:return 'success';
        case 3 :return 'danger';
        default: return '_'
      }
    },

    sendNewAvoir(){
      const status = 1
          AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , this.reason , status )
        .then(avoirId => {
            if(avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
            }
          }) 
        },
 
    addRequestAvoirLine(){
      const lineAvoirRequest = {
                avoirId: this.avoirRequestId  ,
                itemId: this.selectedItem.id,
                quantityAvoir: this.selectedItem.qtyAvoir,
                reason: this.selectedItem.reason,
                batchNumber:this.batchNumber,
                batchDate:this.batchDate,
                expirationDate:this.expirationDate,
                blNumber:this.blNumber,
      };

      AvoirRequestApi.addRequestAvoirLine(lineAvoirRequest )
          .then((avoirId)=>{
            if (avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
              this.selectedItem = {}
              this.batchNumber=""
              this.batchDate=""
              this.expirationDate=""
              this.blNumber=""
            }
          })
    } , 

    removeAvoirLine(line){
        const lineAvoirRequest = {
                    avoirId: this.avoirRequestId,
                    itemId: line.itemId ,
                    quantityAvoir:line.quantityAvoir,
        };
        AvoirRequestApi.deleteAvoirRequestLine(lineAvoirRequest )
        .then(()=>{
            this.getRequestAvoirById()
        } )
    }, 

    getOrderLines(orderId){
      OrdersApi.getOrderLines(orderId).then(
      order => {
          if (order){
          this.orderLines=order.lines
          }}
      )
    },

    getRequestAvoirById(){
      AvoirRequestApi.getRequestAvoirById(this.avoirRequestId  ).then(
        result => {
            if (result){

            this.avoir=result
            this.reason = result.reason
            this.avoirLines =result.lines ?  result.lines : []
            } }
        )
    },

    getOrders() {
      this.isTableLoading = true
      
      if(this.role==0){
        const status = 3 ;

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, false,status,this.isCurrent,this.start,this.end, this.channel ,true)
      .then(orders => {
        if(orders){
          this.ordersList =orders.list ;
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;
        }
      })
      .finally(() => {
        this.isTableLoading=false 
      })
      }
    }, 
  },

  watch: {
    // invoices-list creates this modal only when it opens (v-if), so this must also run on creation:
    // otherwise an existing request opens empty, because its lines are loaded here
    showAddNewAvoirModal: {
      immediate: true,
      handler(isOpen) {
      this.avoirRequestId = this.propsAvoirId
      this.localShowAddNewAvoirModal = isOpen;
      this.orderSelected = null
      if (this.isNew){
        this.reason=null
      }
      this.avoirLines ={}
      if(isOpen && this.avoirRequestId){
        this.getRequestAvoirById(this.avoirRequestId)
      }
      
      },
    }, 

    end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getOrders()
          }   
    },
    start: function(){
        if((this.end && this.start) || (!this.end  && !this.start)  ){
          this.getOrders()
        }
    },

    orderSelected: function(){
        this.orderLineSelected = null;
        if (this.orderSelected){       
            this.getOrderLines(this.orderSelected.id);
            this.quantityAvoir = 0
        }    
    }, 

    orderLineSelected: function(){
      if (this.orderLineSelected){       
          this.quantityAvoir = 0
      }    
    },
  },
  
};
</script>

<template>

<b-modal
  :modal-class="'avoir-printable-modal'"
  v-model="localShowAddNewAvoirModal"
  :title="this.title" 
  title-class="text-primary"
  title-tag="h5"
  header-close-variant="danger"
  size="xl"
  no-close-on-backdrop
  @hide="onCloseAddNewAvoirModal"      
  hide-footer
  ref="itemModal"
  @shown="onShown"

  >

    <div class="d-none d-print-block mb-4">
        <div class="row">
          <div class="col-6">
            <span >
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Nom du client : </span><span>{{this.avoir.customer}}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Adresse : </span><span>{{this.avoir.customerAddress == null ? "" : this.avoir.customerAddress}}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Matricule Fisale : </span><span>{{this.avoir.customerTaxRefNumber == null ? "..................................................................." : this.avoir.customerTaxRefNumber }}</span></h6>
            </span>

          </div>

          <div class="col-6 text-right">
            <vue-barcode
              v-if="avoir.avoirId"
                  :value="avoir.avoirId"
                  :width="2"  :height="50" 
                  background="transparent"
                  fontSize="16" >
                </vue-barcode>

          </div>

        </div>

        <div class="row">
          <div class="col-12 text-right">
            <span>
              <h6 class="font-size-18 mt-5"><span class="font-weight-bold">Date : </span><span>{{this.avoir.date}}</span></h6>
            </span>
          </div>
        </div>
        
        <div class="text-center mt-5 mb-5">
          <h3 class="font-weight-bold mt-2">BON DE RETOUR N° <span>{{avoir.avoirId}}</span></h3>
        </div>

          <div class="row">
          <div class="col-12 ">
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Fournisseur : </span><span>{{this.avoir.supplier == null ? "" : this.avoir.supplier}}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Matricule Fisale : </span><span>{{this.avoir.supplierTaxRefNumber == null ? "" : this.avoir.supplierTaxRefNumber }}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Nom du chauffeur : </span><span>...................................................................</span></h6>
            </span>
          </div>
        </div>
        


    </div>

    <div v-if="this.avoir && !isNew " class="mt-2 pl-3 pb-4 font-size-14 d-print-none">
      <div><strong v-if="role==1">{{this.avoir.customer}}</strong> </div>
      <b-badge href="#" :variant="requestAvoirToColor(this.avoir.status)" class="font-size-12 d-print-none">
        {{requestAvoirStatusToLabel(this.avoir.status)}} 
      </b-badge>
    </div>

         

    <!-- start table-->
    <div class="table-responsive">
        <table class="table print-table-this">
          <thead>
              <tr>
              <th v-if="ischeckBlNumberAvoir" style="width: 50px;font-size: 16px;"><span>Num BL</span></th>
              <th style="min-width: 250px;font-size: 16px;"><span>Article</span></th>
              <th v-if="!isMSS" style="min-width: 150px;font-size: 16px;"><span>Num Lot</span></th>
              <th v-if="!isMSS" style="min-width: 200px;font-size: 16px;"><span>Date Lot</span></th>
              <th style="min-width: 200px;font-size: 16px;" v-if="isAvoirWithExpirationDateEnabled"><span>Date péremption</span></th>
              <th style="min-width: 150px;font-size: 16px;" class="text-left"><span>Qte</span></th>
              <th style="min-width: 150px;font-size: 16px;" class="text-left"><span>Motif de la demande</span></th>
              <!-- <th v-if="this.role==1 || (avoir.status==2 ||avoir.status==3) " style="width: 170px;" class="text-left">Quantité Confirmée</th> -->
              <th class="d-print-none" style="width:50px;"></th>
            </tr>
          </thead>
          <tbody>
              <tr v-if="isNew || (this.role==0 && (avoir.status==0 ||avoir.status==0)) " class="d-print-none" >

                  <td  v-if="ischeckBlNumberAvoir" class="pt-4 pb-4">
                    <div class="row " >
                      <b-input
                          id="blNumber"
                          type="text"
                          class="form-control text-dark font-size-16 font-weight-normal bg-white"
                          style="height:33px;"
                          v-model="blNumber"
                          placeholder="N° BL"
                      />
                    </div>
                  </td>


                  <!-- Select item -->
                  <td class="pt-4 pb-4">
                    <div class="row " >
                      <b-form-input 
                            ref="itemInput"      
                            placeholder="Sélectionner un article"  
                            class="col-11 text-dark font-weight-bold "  
                            :value="selectedItem.ref && selectedItem.title ? selectedItem.ref + ' - ' + selectedItem.title : ''" 
                            :disabled="!isSearchAvoirItemWithBarcodeScannerEnabled" 
                            @keyup.native.enter="findItems($event.target.value)"
                            ></b-form-input> 
                      <i class="col-1 fas fa-pencil-alt font-size-18 text-primary align-middle pl-3 pt-2" style="cursor:pointer ;" @click="showitemModal() ;findItems()"></i>
                    </div>
                  </td>

                  <td v-if="!isMSS" class="pt-4 pb-4">
                    <div>
                        <b-input
                            id="numberInput"
                            type="text"
                            class="form-control text-dark font-size-16 font-weight-normal bg-white"
                            style="height:33px;"
                            v-model="batchNumber"
                            placeholder="N° Lot"
                        />
                    </div>    
                </td>
                

                  <td v-if="!isMSS" class="pt-4 pb-4">
                      <b-form-datepicker
                      v-model="batchDate"
                      :locale="$t('datPicker.locale')"
                      :label-no-date-selected="$t('datPicker.batchDate')"
                      dark
                      reset-button
                      close-button
                      :label-reset-button="$t('datPicker.label-reset-button')"
                      :label-close-button="$t('datPicker.label-close-button')"
                      dropright
                      hide-header
                      ></b-form-datepicker>
                  </td>

                  <td v-if="isAvoirWithExpirationDateEnabled" class="pt-4 pb-4">
                    <b-input
                      id="expirationDateInput"
                      v-model="expirationDate"
                      type="text"
                      class="form-control text-dark font-size-16 font-weight-normal bg-white"
                      style="height:33px;"
                      placeholder="mm/yy"
                      maxlength="5"
                      inputmode="numeric"
                      autocomplete="off"
                      @input="formatExpirationDateInput"
                    />
                  </td>

                  <td class="pt-4 pb-4">
                        <div>
                        <b-input
                        id="quantityInput"
                        type="number"
                        class="form-control text-dark font-size-16 font-weight-normal bg-white"
                        style="height:33px;"
                        v-model="selectedItem.qtyAvoir"
                        placeholder="Qté"
                        />
                        </div>    
                    </td>

                    <td class="pt-4 pb-4">
                      <b-input
                            type="text"
                            class="form-control text-dark font-size-16 font-weight-normal bg-white"
                            style="height:33px;"  @keyup.native.enter="addRequestAvoirLine()"
                            placeholder="Motif de la demande"
                            v-model="selectedItem.reason"
                            
                            />
                  </td>


                  <td class="text-center text-right pt-4 pb-4 d-print-none">
                    <div  >

                      <i class="fas fa-plus-square font-size-22 text-primary align-middle pl-3 pt-2" @click="addRequestAvoirLine()" style="cursor:pointer ;" ></i>

                        <!-- <b-button variant="outline-primary" @click="addRequestAvoirLine()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="isAddRequestLineEnabled">
                               <i class=" fas fa-plus-square font-size-16 font-weight-bold align-middle "></i> Ajouter
                        </b-button> -->
                    </div>             
                </td> 
                  

              </tr>
              <tr v-for="(line,i) in this.avoirLines" :key="i">
                <th v-if="ischeckBlNumberAvoir" style="width: 50px;font-size: 16px;">{{line.blNumber}}</th>
                <td class=" text-left pl-3">
                  <div class="font-weight-bold font-size-14 ">{{line.itemTitle}}</div>
                  <span class="font-size-14"> Réf: {{ line.itemRef }}</span>
                </td>
                <td v-if="!isMSS" class=" text-left font-size-16 pl-3">{{ line.batchNumber }}</td>  
                <td v-if="!isMSS" class=" text-left font-size-16 pl-3">{{ line.batchDate }}</td>  
                <td class=" text-left font-size-16 pl-3">{{ line.expirationDate }}</td>  
                <td class=" text-left font-size-16 pl-3">{{ line.quantityAvoir }}</td>               
                <td class=" text-left font-size-16 pl-3">{{ line.reason }}</td> 
                <td v-if="role==0  && (avoir.status==0 || avoir.status==1)" class=" text-center d-print-none">
                  <i class="mdi mdi-trash-can font-size-22 align-middle text-danger" style="cursor: pointer;" @click="removeAvoirLine(line)"></i>
                </td>
              </tr>
          </tbody>
        </table>
    </div>


    <div class="row mt-5 d-none d-print-block">
      <div class="col-12 text-right">
        <span>
          <h6 class="font-size-18 mt-5 font-weight-bold">Cachet et Signature</h6>
        </span>
      </div>
    </div>

    <div class="row mt-4 ml-4 d-print-none" >
        <div class="col-md-6 col-sm-12 "/>
        <div class="col-md-6 col-sm-12 d-print-none pr-0 text-right ">
              <b-button variant="outline-secondary" class="mr-3 ml-3" v-if="avoir && avoir.status" @click="printModal">
                <i class="fa fa-print font-size-14 align-middle mr-lg-2"></i> <span class="d-none d-lg-inline">{{$t("order.buttons.print")}}   </span>
              </b-button>
            
            <b-button variant="success"  @click="sendNewAvoir"  v-if="role==0 && avoir && avoir.status === 0" >
                <i class="fas fa-paper-plane font-size-14 font-weight-bold align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Envoyer la demande</span>
            </b-button> 
            
            <b-button variant="success"    @click="validateRequest"  v-if="role==1 && avoir && avoir.status != 2" >
                <i class="fas fa-paper-plane font-size-14 font-weight-bold align-middle mr-2"></i> <span class="font-weight-bold font-size-14">Cloturer</span>
            </b-button>
        </div>
    </div> 
<!-- end table-->


<!--  item modal -->    
 <b-modal v-model="showItemsModal" 
      title="Liste des Articles" 
      centered no-footer
      title-tag="h5"
      header-close-variant="danger"
      title-class="text-warning"
      size="xl">
        <div class=" zoom-container">
          <b-input-group  >
            <b-form-input placeholder="Chercher par Référence ou Désignation ou Marque"  v-model="itemsFilter"   @keyup.native.enter="findItems()"
                ></b-form-input>                              
            <template v-slot:append>
                <b-button variant="success" @click="findItems()">
                <i class="bx bx-search-alt font-size-16 align-middle"></i>
                </b-button>
            </template>
          </b-input-group>

          <div class="col">
            <b-table
              :striped="true"
              :small="true"
              :hover="true"
              :items="itemLines"
              :fields="itemFields"
              :busy="isItemsTableBusy"
              
              responsive
              class="col-12 p-3"
            > 
              <template v-slot:cell(actions)="{item}">
                  <a  title="Ajouter" href="javascript:void(0);"  @click="addItems(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-primary">
                    <i class="fas fa-plus-circle font-size-18" />
                  </a>  
              </template>
                              
            </b-table>
            <span v-if="!isItemsTableBusy && !itemLines.length" class="d-flex justify-content-center mr-4 ml-4 mt-4 mb-4 text-danger" >{{ $t("catalog.empty") }} </span>

            <!--Pagination-->         
            <div class="col-12">
                  <div class="row">
                    <div class="col-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findItems()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodelMain.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findItems()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                  </div>
              </div> 
              <!--Fin Pagination-->         
            </div>

        </div>

        <template v-slot:modal-footer>
          <b-button class="zoom-container" variant="secondary" @click="showItemsModal=false" size="md">Annuler</b-button>
        </template> 
  </b-modal>

</b-modal>
</template>
<style>
@media print {
  .table-responsive {
    overflow: visible !important;
  }
  .print-table-this th,
  .print-table-this td {
    border: 1px solid black !important;
    border-collapse: collapse !important;
    color: black;
  }
  .print-table-this{
    color: black;
    page-break-inside: auto;
  }
  h3,h6{
    color: black;
  }
  span{
    color: black;
  }
  .print-table-this tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  .print-table-this thead {
    display: table-header-group;
  }

  .print-table-this tbody {
    display: table-row-group;
  }


  .avoir-printable-modal {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important; 
    min-width: 100% !important;
    max-width: 100% !important;
    height: 100vh !important;
    min-height: 100vh !important;
    max-height: 100vh !important;
    background: white !important;
    padding: 0 !important;
    margin-bottom: 20px !important;
    overflow: visible !important;
    z-index: 9999 !important;
  }

  .avoir-printable-modal .modal,
  .avoir-printable-modal .modal-dialog,
  .avoir-printable-modal .modal-content {
    position: static !important;
    top: 0 !important;
    left: 0 !important;
    transform: none !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 20px !important;
    padding: 0 !important;
    box-shadow: none !important;
    background-color: white !important;
  }

  .avoir-printable-modal .modal-backdrop {
    display: none !important;
  }
  .avoir-printable-modal,
  .avoir-printable-modal * {
    visibility: visible;
  }

}
</style>


